module.exports = __webpack_public_path__ + "static/media/exhibition-services-img7.3db6aea5.jpg";